import Section from '../ui/Section/Section'
import Reveal from '../ui/Reveal/Reveal'
import Button from '../ui/Button/Button'
import SocialLinks from '../ui/SocialLinks/SocialLinks'
import { ArrowRightIcon } from '../ui/Icon/Icon'
import { social } from '../../data/portfolio'
import styles from './Contact.module.css'

const Contact = ({ index }) => {
  if (!social.email) return null

  return (
    <Section id="contact" index={index} title="Get in touch" eyebrow="Contact">
      <Reveal className={styles.panel}>
        <div className={styles.glow} aria-hidden="true" />

        <p className={styles.copy}>
          I&rsquo;m open to new roles, freelance work and interesting
          collaborations. If you have something in mind, or just want to say
          hello, my inbox is always open.
        </p>

        <div className={styles.actions}>
          <Button href={`mailto:${social.email}`}>
            {social.email}
            <ArrowRightIcon size={18} />
          </Button>

          <SocialLinks />
        </div>
      </Reveal>
    </Section>
  )
}

export default Contact
